import Model, { attr, belongsTo } from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';
import type Flow from 'invite-sign/models/flow';

export default class IdScanPage extends Model {
  declare [Type]: 'id-scan-page';

  @belongsTo('flow', { async: false, inverse: 'idScanPage' }) declare flow: Flow;

  @attr('boolean') declare enabled: boolean;
}
